import Sucursales from './Sucursales'

export default Sucursales
